import React from 'react';
import { products } from '../../data/products';
import Button from '../ui/Button';
import SafeIcon from '../../common/SafeIcon';

const MadeWithModule = () => {
  const product = products.find((item) => item.id === 'powder-100g');
  if (!product) return null;

  return (
    <div className="bg-sand-light rounded-3xl p-8 border border-sand">
      <h3 className="font-serif text-2xl text-gray-900 mb-6">Made with UBEA</h3>
      <div className="flex flex-col sm:flex-row items-center gap-6">
        <div className="w-24 h-24 rounded-2xl overflow-hidden shadow-md flex-shrink-0 bg-white">
          <img src={product.image} alt={product.name} className="w-full h-full object-cover" />
        </div>
        <div className="flex-grow text-center sm:text-left">
          <h4 className="font-serif text-lg text-ube-dark mb-1">{product.name}</h4>
          <p className="text-sm text-gray-600 mb-4">{product.size} • ${product.price}</p>
          <Button to={`/shop/${product.id}`} variant="primary" size="sm" className="w-full sm:w-auto">
            <SafeIcon name="ShoppingCart" className="w-4 h-4 mr-2" />
            Shop Ube Powder
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MadeWithModule;